import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { AcctShell } from "../features/acct/AcctShell";
import { PayrollPostPanel } from "../features/acct/PayrollPostPanel";
import { accruePayroll, payPayroll, payrollPostStatus } from "../api/acctExport";
import { listBoxes } from "../api/accounting";
import { useApiError } from "../hooks/useApiError";
import { NeuCard, NeuInput } from "../components/neu/Neu";

export default function AcctPayrollPostPage() {
  const { t } = useTranslation();
  const describe = useApiError();
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [status, setStatus] = useState(null);
  const [boxes, setBoxes] = useState([]);
  const [box, setBox] = useState("");
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => setStatus(await payrollPostStatus(month)), [month]);
  useEffect(() => {
    load();
  }, [load]);
  useEffect(() => {
    listBoxes().then((list) => {
      setBoxes(list);
      setBox(list[0]?.id || "");
    });
  }, []);

  const act = async (kind) => {
    setBusy(true);
    try {
      await (kind === "accrue" ? accruePayroll(month) : payPayroll(month, box));
      toast.success(t("acct.payrollPost.posted"));
      load();
    } catch (error) {
      toast.error(describe(error));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AcctShell titleKey="payrollPost">
      <NeuCard className="flex flex-wrap items-end gap-4 p-4">
        <div className="w-44">
          <p className="label-xs mb-2">{t("acct.payrollPost.month")}</p>
          <NeuInput type="month" data-testid="pp-month" value={month} onChange={(e) => setMonth(e.target.value)} />
        </div>
        <p className="text-xs text-muted-foreground">{t("acct.payrollPost.hint")}</p>
      </NeuCard>

      <PayrollPostPanel status={status} boxes={boxes} box={box} setBox={setBox} busy={busy} onAct={act} />
    </AcctShell>
  );
}
